module.exports = __webpack_public_path__ + "img/Dayana-Powe.23c1f8c4.jpg";